<div class="content-container mb-3">
    <div class="title d-inline-flex w-100">
        Table With All Sample Controls
    </div>
    <div class="content d-flex flex-wrap">
        @if (matTableData) {
            <mwp-table [tableColumns]="tableColumns" [dataSource]="matTableData" />
        }
    </div>
</div>
<div class="content-container mb-4">
    <div class="title d-inline-flex w-100">
        Table With No Data
    </div>
    <div class="content d-flex flex-wrap">
        @if (matTableData) {
            <mwp-table [tableColumns]="tableColumns" [dataSource]="matTableData2" />
        }
    </div>
</div>
<hr/>
<div class="fw-bold mb-2">
    Example My Benefits with Child Table
</div>
<div>
    <mwp-card-benefit-summary
      [header]="'Current Benefits'"
      [benefitSummaryList]="benefits"
      [displayCategoryColumn]="true"
      [displayBenefitColumn]="true"
      [enableToggle]="true" />
</div>
    